import React from 'react';
import { Accordion, Button, Container, Grid, Header, Divider } from 'semantic-ui-react';

import MenuItem from './MenuItem';

export default class MenuSection extends React.Component {
  constructor() {
    super();
    this.state = { active: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  render() {
    const {
      asAccordion,
      centerHeaders,
      imageSize,
      itemAs,
      itemsPerRow,
      sectionItems,
      sectionTitle,
      sectionDescription,
    } = this.props;
    const { active } = this.state;
    if (asAccordion) {
      return (
        <Accordion style={{ margin: '0 0 2.5rem 0' }} id={sectionTitle}>
          <Accordion.Title active={active} onClick={this.handleClick}>
            <Grid columns={1} centered={centerHeaders}>
              <Header as="h2">{sectionTitle}</Header>
            </Grid>
            <Grid columns={1} centered={centerHeaders}>
              <Header as="h4" style={{ marginTop: '0.2em' }}>
                {sectionDescription}
              </Header>
            </Grid>
            <Grid
              columns={1}
              centered={centerHeaders}
              style={{ marginBottom: '2em', textAlign: `${centerHeaders ? 'center' : 'left'}` }}
            >
              <Button style={{ background: 'none', border: 'none' }} onClick={this.handleClick}>
                {active ? 'Show Less' : 'Show More'}
              </Button>
            </Grid>
          </Accordion.Title>
          <Accordion.Content active={active}>
            <Grid
              columns={itemsPerRow}
              stackable
              style={{ textAlign: centerHeaders ? 'center' : 'left' }}
            >
              {sectionItems.map(item => (
                <Grid.Column key={item.itemTitle}>
                  <MenuItem
                    {...item}
                    imageSize={imageSize}
                    itemAs={itemAs}
                    align={centerHeaders ? 'center' : 'left'}
                  />
                </Grid.Column>
              ))}
            </Grid>
          </Accordion.Content>
        </Accordion>
      );
    }
    return (
      <Container id={sectionTitle}>
        <Grid columns={1} centered={centerHeaders}>
          <Divider section />
        </Grid>
        <Grid columns={1} centered={centerHeaders}>
          <Header as="h2">{sectionTitle}</Header>
        </Grid>
        <Grid columns={1} centered={centerHeaders}>
          <Header as="h4" style={{ marginTop: '0.2em', marginBottom: '2em' }}>
            {sectionDescription}
          </Header>
        </Grid>
        <Grid
          columns={itemsPerRow}
          stackable
          style={{ textAlign: centerHeaders ? 'center' : 'left' }}
        >
          {sectionItems.map(item => (
            <Grid.Column key={item.itemTitle}>
              <MenuItem
                {...item}
                align={centerHeaders ? 'center' : 'left'}
                imageSize={imageSize}
                itemAs={itemAs}
              />
            </Grid.Column>
          ))}
        </Grid>
      </Container>
    );
  }
}
